const IMAGE_WIDTH = 100;
const IMAGE_HEIGHT = 56;
const POSTER_DIMENSIONS = {
    WIDTH: 400,
    HEIGHT: 225,
};

const IMAGE_TEMPLATE = "-1x-1";

export function generateSmallThumbnailUrl(
    url: string,
    width: number = IMAGE_WIDTH,
    height: number = IMAGE_HEIGHT
) {
    if (!(url && url.replace)) {
        return url;
    }

    const imageSize = `${width}x${height}`;
    return url.replace(IMAGE_TEMPLATE, imageSize);
}

export function generatePosterUrl(url: string) {
    if (!(url && url.replace)) {
        return url;
    }

    const imageSize = `${POSTER_DIMENSIONS.WIDTH}x${POSTER_DIMENSIONS.HEIGHT}`;
    return url.replace(IMAGE_TEMPLATE, imageSize);
}
